import {Space, Typography} from "antd";

export const CategoryHeader = ({ name, total }) => {
  return(
    <div className="boxStyle">
      <Space>
        <Typography.Title>Category: <Typography.Text type="success" italic>{name}</Typography.Text></Typography.Title>
        <Typography.Title>Total Records: <Typography.Text italic type="danger">{total}</Typography.Text></Typography.Title>
      </Space>
    </div>
  )
}